module.exports = __webpack_public_path__ + "media/images/landing/blended-9b79b4d13e76986c52ddbbba6a92d2b1.png";